import { Container, Row, Col, Spinner, Table, Button, Modal } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { AiOutlineLeft } from 'react-icons/ai'
import { Link, useParams } from 'react-router-dom'
import Actions from "../redux/actions";
import API from '../api/api'

export default function BlockedEmailViewer(props) {

    const { id } = useParams()

    const user = useSelector(state => state.user)
    const accounts = useSelector(state => state.accounts)
    const blockedEmails = useSelector(state => state.blockedEmails)
    const [blockedEmail, setBlockedEmail] = useState()
    const [loading, setLoading] = useState(true)
    const dispatch = useDispatch()
    useEffect(() => {

        document.title = 'ScamWall | Email Blocked'
        if (blockedEmails) {
            setBlockedEmail(blockedEmails.find(bl => bl._id === id))
            document.getElementById('email-content').contentWindow.document.write(blockedEmails.find(bl => bl._id === id).body)
            document.getElementById('email-content').height = `${window.innerHeight / 1.8}`
            setLoading(false)
        } else {
            _setup()
        }

    }, [blockedEmails])


    const _setup = async () => {
        dispatch(Actions.setBlockedEmails(await API.getBlockedEmails()))
    }

    const _updateStatus = async (status) => {
        setLoading(true)
        const updated = await API.updateBlockedEmail(id, status)
        setBlockedEmail(updated)
        setLoading(false)

        dispatch(Actions.updateBlockedEmail(updated))
        if (status === 'APPROVED') {
            dispatch(Actions.setToast('Email Approved', 'Links will now be clickable!'))
        } else {
            dispatch(Actions.setToast('Email Denied', 'Links will still be blocked in this email'))

        }
    }

    return (
        <Container fluid className='pt-4 ps-4 m-0 text-center'>
            <div className='text-start'>
                <Link variant='link' to='/email' className='text-start'><AiOutlineLeft /> Go Back</Link>
            </div>
            <h2>Review the Email</h2>
            <p>All links have been blocked in this email for this user. If you would like to give access, please approve</p>
            <p><b>Current Status: </b>{blockedEmail?.status}</p>
            <Row>
                <Col md={4} className='mx-auto'>
                    <Row className='justify-content-center'>
                        <Col md={4} className='mt-1'>
                            <Button className='w-100' disabled={loading} onClick={() => _updateStatus('DENIED')} >Deny</Button>
                        </Col>
                        <Col md={4} className='mt-1'>
                            <Button variant='success text-white w-100' disabled={loading} onClick={() => _updateStatus('APPROVED')} >Approve</Button>
                        </Col>
                    </Row>
                </Col>
            </Row>

            {loading && <div className='text-center my-3'><Spinner animation='border' /></div>}


            <Row className='mt-3'>
                <Col md={7} className='mx-auto border rounded shadow p-4 h-100'>
                    <h5><b>From: </b> {blockedEmail?.from}</h5>
                    <h5><b>Subject: </b> {blockedEmail?.subject}</h5>
                    <hr />
                    <iframe id='email-content' title='email body' className='w-100 ' height='300' />
                </Col>
            </Row>


        </Container >
    )
}